import { render, staticRenderFns } from "./HttpBody.vue?vue&type=template&id=bf146d62"
import script from "./HttpBody.vue?vue&type=script&lang=js"
export * from "./HttpBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports